var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M15.692 36A3.692 3.692 0 0112 32.308V15.692A3.692 3.692 0 0115.692 12h16.616A3.692 3.692 0 0136 15.692v13.88L29.539 36H15.692zm16.49-22H15.818c-.958 0-1.744.742-1.813 1.682l-.005.136v16.364c0 .958.742 1.744 1.682 1.813l.136.005h12.797v-4.385a1 1 0 011-1H34V15.818c0-.91-.67-1.665-1.543-1.797l-.14-.016-.135-.005z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
